export default __webpack_public_path__ + "static/media/img_muslinTwoBunnyEars_rg.acd20e5f.jpg";